import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ptBR } from '@/i18n/pt-BR';
import { useApiClient } from '@/lib/api';
import { cadastroPublicoAberto } from '@/lib/auth';

/**
 * O "Criar conta" da tela de entrada (E166.F2.T03): só aparece quando a api diz que o cadastro
 * público está aberto (DEV). Em produção e homologação as contas nascem pelo administrador do
 * escritório, pelo gestor do banco ou pelo console.
 */
export function LinkDoCadastro() {
  const apiClient = useApiClient();
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    let vivo = true;
    void cadastroPublicoAberto(apiClient).then((resposta) => {
      if (vivo) setAberto(resposta);
    });
    return () => {
      vivo = false;
    };
  }, [apiClient]);

  if (!aberto) return null;
  return (
    <span>
      {ptBR.login.noAccount}{' '}
      <Link
        to="/signup"
        className="text-accent-700 underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-accent"
      >
        {ptBR.login.signupCta}
      </Link>
    </span>
  );
}
